import { useSelector } from 'react-redux'

export const useAuth = () => {
  const auth = useSelector((state) => state.user?.info?.accessToken)
  return auth ? true : false
}
